export default __webpack_public_path__ + "static/media/cellnet_logo_old.9e3e04c4.svg";